// extracted by mini-css-extract-plugin
module.exports = {"app":"app__OqKs7","pageContent":"pageContent__1b-rW","topOffCanvas":"topOffCanvas__taM6I"};